import { Row, Skeleton, Empty, notification } from "antd";
import { useEffect, useState } from "react";
import { ContentHeader } from "../../components/ContentHeader/ContentHeader";
import CapacitiesList from "../../components/Capacities/Capacities-list";
import { useSearchCapacities } from "../../../hooks/capacities-hook";

interface Props {
  data: any;
}
const Capacities = ({ data }: Props) => {
  const { result, searchCapacities } = useSearchCapacities();
  const [capacity, setCapacity] = useState(data.capacity);
  useEffect(() => {
    document.title = "UNAB - Capacidades";
    setCapacity(data.capacity);
  }, []);
  return (
    <div className="full-width">
      <div className="content-header">
        <ContentHeader title="Capacidades" />
      </div>
      <Skeleton loading={data.isLoading} active className="full-width">
        <div className="full-width">
          <Row
            gutter={[8, 8]}
            style={{
              width: "100%",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {data.initialDataCapacities.length > 0 ? (
              <CapacitiesList
                loading={data.loading}
                list={data.initialDataCapacities}
              />
            ) : (
              <Empty />
            )}
          </Row>
        </div>
      </Skeleton>
    </div>
  );
};

export default Capacities;
